import { render, staticRenderFns } from "./TableProfileSupAdmin.vue?vue&type=template&id=2840b7f0&scoped=true&"
import script from "./TableProfileSupAdmin.vue?vue&type=script&lang=js&"
export * from "./TableProfileSupAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TableProfileSupAdmin.vue?vue&type=style&index=0&id=2840b7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840b7f0",
  null
  
)

export default component.exports